module.exports = __webpack_public_path__ + "static/media/renovation.34efb0d4.jpeg";